export const keys = {
  english: 'english',
  spanish: 'spanish',
};
